import { supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';
import { ICardSet, ISaveCardSet } from '../models';

class CardSetClient extends NewBaseClient<ISaveCardSet, ICardSet> {
    constructor() {
        super(supportApi, '/card-sets');
    }
}

export const cardSetClient = new CardSetClient();
